"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";
import Image from "next/image";

export default function Card({
  icon,
  title,
  description,
  onClick,
  className = "",
  style = {},
  titleClassName = "",
  descriptionClassName = "",
}) {
  const isdark = useIsDark();

  return (
    <button
      onClick={onClick}
      className={twMerge(
        "flex flex-col w-full pb-3 px-2.5 mobile2:px-2 tablet:pb-5 tablet:px-3 laptop:pb-[25px] xl:px-5 5xl:px-6 relative z-10",
        className
      )}
      style={style}
    >
      {icon && (
        <div className="relative w-6 mobile:w-9 mobile2:w-6 md:w-8 lg:w-10 xl:w-12 laptop:w-[54px] 3xl:w-[65px] 5xl:w-[72px] ml-1 mt-2 tablet:mt-4 laptop:mt-[26px] 4xl:mt-10 5xl:mt-15 aspect-square">
          <Image src={icon} alt="icon" fill className="object-contain" />
        </div>
      )}
      <p
        className={twMerge(
          "font-manrope font-semibold text-[14px] mobile:text-[18px] mobile2:text-[14px] md:text-[17px] lg:text-xl xl:text-2xl 3xl:text-[28px] 4xl:text-3xl 5xl:text-[32px] tracking-tight bg-clip-text text-transparent bg-linear-to-r from-[#FF1CF7] mt-4 mobile2:mt-2 md:mt-4 laptop:mt-9 text-left",
          isdark ? "to-[#EEEEFF]" : "to-[#1A1A1A]",
          titleClassName
        )}
      >
        {title}
      </p>
      <div className="h-px w-1/2 mt-3 lg:mt-5 xl:mt-7 dark:bg-[#FF1CF7] bg-[#5A5A6E]"></div>
      <p
        className={twMerge(
          "font-manrope font-normal text-[10px] mobile:text-[13px] mobile2:text-[10px] md:text-[12px] lg:text-sm xl:text-[17px] 4xl:text-[20px] 5xl:text-[22px] mt-3 lg:mt-5 xl:mt-7 dark:text-[#FF1CF7] text-[#5A5A6E] text-left",
          descriptionClassName
        )}
      >
        {description}
      </p>
    </button>
  );
}
